export default __webpack_public_path__ + "static/metro-north-railroad-78a9777a79e8645e66404648200200ee.png";